import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/pc",
    component: () => import("../views/Pc.vue"),
    children: [
      {
        path: "/",
        redirect: "meetingInfo"
      },
      {
        path: "meetingInfo",
        name: "MeetingInfo",
        component: () => import("../views/pc/MeetingInfo.vue")
      },
      {
        path: "meeting",
        name: "Meeting",
        children: [
          {
            path: "/",
            name: "Introduce",
            component: () => import("../components/pc/Introduction.vue")
          },
          {
            path: "introduce",
            name: "Introduce",
            component: () => import("../components/pc/Introduction.vue")
          },
          {
            path: "schedule",
            name: "Schedule",
            component: () => import("../components/pc/Schedule.vue")
          },
          {
            path: "guests",
            name: "Guests",
            component: () => import("../components/pc/Guests.vue")
          },
          {
            path: "expand",
            name: "Expand",
            component: () => import("../components/pc/Expand.vue")
          }
        ],
        component: () => import("../views/pc/Meeting.vue")
      }
    ]
  },
  {
    path: "/wap",
    component: () => import("../views/Wap.vue"),
    children: [
      {
        path: "/",
        redirect: "meetingInfo"
      },
      {
        path: "meetingInfo",
        name: "MeetingInfo",
        component: () => import("../views/wap/MeetingInfo.vue")
      },
      {
        path: "meeting",
        name: "Meeting",
        component: () => import("../views/wap/Meeting.vue")
      }
    ]
  }
];

const router = new VueRouter({
  routes
});
export default router;
